import { classNames } from 'primereact/utils'

const TRANSITIONS = {
    overlay: {
        enterFromClass: 'opacity-0 scale-75',
        enterActiveClass:
            'transition-transform transition-opacity duration-150 ease-in',
        leaveActiveClass: 'transition-opacity duration-150 ease-linear',
        leaveToClass: 'opacity-0',
    },
}

const dropdown = {
    root: ({
        props,
        attrs,
        state,
    }: {
        props: any
        attrs: any
        state: any
    }) => ({
        className: classNames(
            // Display and Position
            'inline-flex',
            'relative',
            // Shape
            {
                'rounded-full': attrs?.type === 'filter',
                'rounded-md	': !attrs?.type,
            },
            // Color and Background
            'bg-white',
            'border border-solid border-grey-5',

            { 'text-allstate-blue font-bold': attrs?.type === 'filter' },
            'text-base',
            // Transitions
            'transition-all',
            'duration-200',
            // States
            { 'hover:border-primary': !props.invalid },
            {
                'outline-none outline-offset-0 ring ring-primary-400/50':
                    state.focused,
            },
            // Misc
            'cursor-pointer',
            'select-none',
            {
                'opacity-60': props.disabled,
                'pointer-events-none': props.disabled,
                'cursor-default': props.disabled,
            }
        ),
    }),
    input: ({ props }: { props: any }) => ({
        className: classNames(
            'cursor-pointer block flex flex-auto overflow-hidden overflow-ellipsis whitespace-nowrap relative',
            'bg-transparent border-0 text-gray-800',
            'p-3 transition duration-200 bg-transparent rounded appearance-none font-sans text-base',
            'focus:outline-none focus:shadow-none',
            { 'pr-7': props.showClear }
        ),
    }),
    trigger: {
        className: classNames(
            'flex items-center justify-center shrink-0',
            'bg-transparent text-gray-500 w-12 rounded-tr-lg rounded-br-lg'
        ),
    },
    wrapper: {
        className: classNames(
            'max-h-[200px] overflow-auto',
            'bg-white text-gray-700 border-0 rounded-md shadow-lg'
        ),
    },
    list: 'p-0 list-none m-0',
    item: ({ context }: { context: any }) => ({
        className: classNames(
            'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
            'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',

            'hover:text-gray-700 hover:bg-gray-200',
            {
                'text-gray-700': !context.focused && !context.selected,
                'bg-gray-300 text-gray-700':
                    context.focused && !context.selected,
                'bg-faded-blue text-allstate-navy':
                    context.focused && context.selected,
                'bg-faded-blue text-allstate-blue':
                    !context.focused && context.selected,
                'opacity-60 select-none pointer-events-none cursor-default':
                    context.disabled,
            }
        ),
    }),
    itemgroup: {
        className: classNames(
            'm-0 p-3 text-gray-800 bg-white font-bold',
            'cursor-auto'
        ),
    },
    header: {
        className: classNames(
            'p-3 border-b border-gray-300 text-gray-700 bg-gray-100 mt-0 rounded-tl-lg rounded-tr-lg'
        ),
    },
    filtercontainer: 'relative',
    filterinput: {
        className: classNames(
            'pr-7 -mr-7',
            'w-full',
            'font-sans text-base text-gray-700 bg-white py-3 px-3 border border-gray-300 transition duration-200 rounded-lg appearance-none',
            'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]'
        ),
    },
    filtericon: '-mt-2 absolute top-1/2',
    clearicon: 'text-gray-500 right-12 -mt-2 absolute top-1/2',
    transition: TRANSITIONS.overlay,
}

export default dropdown
